/**
 * Generated by @openapi-codegen
 *
 * @version 1.0.0
 */
import * as reactQuery from 'app/src/shared/helpers/reactquery'
import { ContactsContext, useContactsContext } from './contacts-context'
import type * as Fetcher from './contacts-fetcher'
import { contactsFetch } from './contacts-fetcher'
import type * as Schemas from './contacts-schemas'

export type ContactsRequestListPathParams = {
  templateBasePath: string
}

export type ContactsRequestListHeaders = {
  ['X-Locale']?: string
}

export type ContactsRequestListError = Fetcher.ErrorWrapper<{
  status: 400
  payload: {
    /**
     * Error type
     */
    type: string
    /**
     * HTTP status
     */
    status: number
    /**
     * Error message
     */
    title: string
    /**
     * Unique return code
     *
     * @format int32
     */
    rc?: number
  }
}>

export type ContactsRequestListVariables = {
  headers?: ContactsRequestListHeaders
  pathParams: ContactsRequestListPathParams
} & ContactsContext['fetcherOptions']

/**
 * Returns the list of the Contacts
 */
export const fetchContactsRequestList = (variables: ContactsRequestListVariables, signal?: AbortSignal) =>
  contactsFetch<
    Schemas.Contacts,
    ContactsRequestListError,
    undefined,
    ContactsRequestListHeaders,
    {},
    ContactsRequestListPathParams
  >({
    url: '/{templateBasePath}/pages/contacts',
    method: 'get',
    ...variables,
    signal,
  })

/**
 * Returns the list of the Contacts
 */
export const useContactsRequestList = <TData = Schemas.Contacts>(
  variables: ContactsRequestListVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<Schemas.Contacts, ContactsRequestListError, TData>,
    'queryKey' | 'queryFn' | 'initialData'
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useContactsContext(options)
  return reactQuery.useQuery<Schemas.Contacts, ContactsRequestListError, TData>({
    queryKey: queryKeyFn({
      path: '/{templateBasePath}/pages/contacts',
      operationId: 'contactsRequestList',
      variables,
    }),
    queryFn: ({ signal }) => fetchContactsRequestList({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  })
}

export type QueryOperation = {
  path: '/{templateBasePath}/pages/contacts'
  operationId: 'contactsRequestList'
  variables: ContactsRequestListVariables
}
